"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _constants = require("../constants");
var _icon_helpers = require("./icon_helpers");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var RatingStrongYesIcon = function RatingStrongYesIcon(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 20 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 20 : _ref$height,
    _ref$unselected = _ref.unselected,
    unselected = _ref$unselected === void 0 ? false : _ref$unselected;
  var fillColor = unselected ? _icon_helpers.unselectedStrokeStrongYesOrNoColor : _constants.colors.mediumGreenhouseGreen;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height
  }, /*#__PURE__*/React.createElement("path", {
    fill: fillColor,
    d: "M7.195 6.955L9.335.48c.211-.639 1.114-.639 1.325 0l2.14 6.476h6.496c.655 0 .949.82.444 1.236l-5.226 4.307 1.9 6.609c.184.639-.545 1.148-1.082.755l-5.334-3.904-5.335 3.904c-.537.393-1.266-.116-1.082-.755l1.9-6.609L.255 8.191C-.25 7.775.045 6.955.7 6.955h6.496z"
  }));
};
var _default = exports["default"] = RatingStrongYesIcon;